import Udesk from 'Udesk';
import React, { FC, memo, useMemo, useState } from 'react';
import { useEffect } from 'react';
import { Tabs } from 'udesk-ui';
import Page from 'Component/common/udesk-qa-page-layout';
import SubRoutes from 'udesk-react/src/components/sub-routes';
import './feishu-qa-entry.scss';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps {
    history?: any;
    match?: any;
    routes?: any[];
}

const Template: FC<TemplateProps> = memo((props) => {
    const ADD_TYPES = useMemo(
        () => [
            {
                pathName: 'feishuQaChatRecord',
                key: 'text',
                text: /* 实时消息 */UdeskLocales['current'].pages.feishuQa.feishuQaEntry.realtimeMessage,
                id: 'text',
            },
            {
                pathName: 'feishuGroupDialogueManage',
                key: 'group-dialogue-manage',
                text: /* 群聊切分 */UdeskLocales['current'].pages.feishuQa.feishuQaEntry.groupChatSegmentation,
                id: 'group-dialogue-manage',
            },
        ],
        []
    );

    const [activeKey, setActiveKey] = useState<'text' | 'group-dialogue-manage'>('text');
    const onAddTypeChange = (activeKey) => {
        setActiveKey(activeKey);
        const tab: any = ADD_TYPES.find((t) => t.key === activeKey) ?? {};
        const routeOptions = {
            history: props.history,
            routeName: tab.pathName,
            pathParams: { taskId: props.match.params.taskId },
        };
        Udesk.ui.routing.transitionTo(routeOptions);
    };

    useEffect(() => {
        const currentPath = ADD_TYPES.find(
            (item) => props.history.location.pathname.indexOf(item.id) >= 0
        );
        if (currentPath) {
            setActiveKey(currentPath.key as any);
        }
    }, [ADD_TYPES, props.history.location]);

    return (
        <Page
            pageBodyClassName="udesk-qa-wechat-qa-chart-record-index"
            title={/* 飞书会话 */UdeskLocales['current'].pages.feishuQa.feishuQaEntry.flyingBookConversation}
            padding={0}
            footer={
                <Tabs activeKey={activeKey} onChange={onAddTypeChange}>
                    {props.routes?.map((item, i) => {
                        const tab: any = ADD_TYPES.find((t) => t.pathName === item.name) ?? {};
                        if (tab.hidden) return null;
                        return <Tabs.TabPane tab={tab.text} key={tab.key}></Tabs.TabPane>;
                    })}
                </Tabs>
            }
        >
            <SubRoutes
                route={props.routes?.find(
                    (r) => r.name === ADD_TYPES.find((i) => i.key === activeKey)!.pathName
                )}
            />
        </Page>
    );
});

class Component extends React.Component {
    render() {
        return <Template {...this.props} />;
    }
}

export default Udesk.react.udeskify(Component);
